import { useMutation } from '@tanstack/react-query';
import { completeExternalConnectionAuth } from 'shared/services/backend-api';

export const useCompleteExternalConnectionAuthMutation = () =>
  useMutation({
    mutationFn: (connectionToken: string) =>
      completeExternalConnectionAuth(connectionToken),
  });
